import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholifarmhous() {



    const cardData =
    {
        keyword: 'Morachi Chincholi Farmhouse Near Pune on Rent',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi Farmhouse Near Pune on Rent',
        headingDescription: 'Searching for a spacious and serene Morachi Chincholi farmhouse near Pune on rent? Anand Krushi Paryatan Kendra offers an ideal farm stay experience set across 40 acres of lush farmland, just 55 km from Pune. Perfect for family gatherings, celebrations, corporate retreats, and weekend getaways, this farmhouse rental combines rural charm with modern conveniences. Guests can enjoy a full day of activities including bullock cart and tractor rides, horse riding, boating, swimming, rain dance, and traditional village games. The farmhouse provides comfortable spaces for hosting events and relaxing in nature, surrounded by greenery and free-roaming peacocks.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Spacious Farmhouse Rentals",
    "description": "Rent large farmhouses with ample indoor and outdoor space, perfect for family reunions, corporate retreats, and weekend getaways. These farmhouses offer multiple bedrooms, living areas, and large verandas overlooking lush farmland."
  },
  {
    "title": "Fully Equipped Kitchens",
    "description": "Most farmhouses come with fully functional kitchens where guests can cook their own meals or hire local chefs to prepare authentic Maharashtrian dishes using fresh, farm-grown ingredients."
  },
  {
    "title": "Private Outdoor Areas",
    "description": "Enjoy private lawns, garden spaces, and courtyards for barbecues, outdoor games, or bonfire nights. Many farmhouses have dedicated spots for rain dance or splash pool setups."
  },
  {
    "title": "Traditional Rustic Ambience",
    "description": "Experience the charm of rural Maharashtra with traditional decor, mud walls, wooden beams, and handcrafted furniture that blends comfort with authenticity."
  },
  {
    "title": "Animal Interaction & Farm Activities",
    "description": "Some rented farmhouses include access to small farms with cows, goats, and poultry, where guests—especially children—can experience milking, feeding animals, or learning about dairy farming."
  },
  {
    "title": "Outdoor Games & Adventure",
    "description": "Spaces for classic village games like lagori, kho-kho, and gilli-danda. Larger properties may also offer rope courses, swings, and cycling tracks."
  },
  {
    "title": "Event Hosting & Celebration Friendly",
    "description": "Many farmhouses are available for special occasions like birthday parties, anniversaries, and small weddings, offering indoor halls or open spaces for decorations and catering."
  },
  {
    "title": "Close Proximity to Pune",
    "description": "Located just 50-60 km from Pune, these farmhouses provide easy weekend escapes from city life without long travel times."
  },
  {
    "title": "Flexible Booking Options",
    "description": "Options range from single-day rentals to multi-night stays, with customizable packages including meals, guided farm tours, and activity access."
  },
  {
    "title": "Contact & Booking Assistance",
    "description": "Most farmhouses can be booked directly through local agents or online platforms. Assistance for group bookings and special requests is often available."
  }
],




  "services": [
    {
      "name": "Farmhouse Rentals for Weekend Stays",
      "description": "Private farmhouse stays offering full weekend experiences—cozy bedrooms, open lawns, garden seating, bonfires, and leisure activities designed for families and small groups wanting a relaxed country break."
    },
    {
      "name": "Private Farmhouse Near Pune",
      "description": "Secluded farmhouses a short drive from Pune, giving you private access to the property—ideal for families, couples, or groups looking for undisturbed countryside time with comfort and convenience."
    },
    {
      "name": "Family Farmhouse on Rent in Morachi Chincholi",
      "description": "Large farmhouses equipped with multiple bedrooms and a safe outdoor play area—perfect for multi-generational family vacations with space, privacy, and rustic charm."
    },
    {
      "name": "Farmhouses with Kitchen Facilities",
      "description": "Self-cook friendly properties featuring well-equipped kitchens—ideal for families or groups who love preparing meals with fresh farm produce in a home-like environment."
    },
    {
      "name": "Pet-Friendly Farmhouses",
      "description": "Farmhouse rentals that welcome furry family members too! Spacious grounds, secure boundaries, and pet amenities make it easy and enjoyable to bring your pets along."
    },
    {
      "name": "Farmhouse with Garden and Outdoor Seating",
      "description": "Beautiful farmhouses featuring lush kitchen gardens and cozy outdoor seating areas—perfect for morning tea among flowers or evening relaxation under the stars."
    },
    {
      "name": "Budget-Friendly Farmhouse Options",
      "description": "Affordable farmhouse rentals near Pune and Morachi Chincholi offering comfortable stays, open space, and basic amenities—great value for budget-conscious guests."
    },
    {
      "name": "Farmhouse for Birthday Party",
      "description": "Celebrate milestones with private farmhouse rentals that include party setups, garden décor, optional catering, and activity zones for birthday fun and memories."
    },
    {
      "name": "Group Stay Farmhouse Near Pune",
      "description": "Choose spacious farmhouses with multiple rooms and shared living spaces—perfect for groups of friends, college outings, or extended family stays with meals and entertainment."
    },
    {
      "name": "Farmhouse with Local Food Availability",
      "description": "Properties offering optional local-cuisine meal services—enjoy authentic Maharashtrian spreads prepared fresh using organic farm ingredients without needing to cook yourself."
    },
    {
      "name": "Secluded Farmhouse for Peaceful Stay",
      "description": "Escape the crowds in private farmhouses set amidst fields and greenery—ideal for quiet retreats, solo relaxation, or romantic getaways in nature’s peace."
    },
    {
      "name": "One-Day Farmhouse Rentals",
      "description": "Perfect for short visits—enjoy a full day at the farmhouse with kitchen access, garden seating, optional meals, and outdoor fun without needing an overnight stay."
    },
    {
      "name": "Traditional Village‑Style Farmhouse Stays",
      "description": "Experience rural architecture with thatched roofs, mud walls, woven charpais, and traditional décor—immersive village-style stays offering authentic countryside living."
    },
    {
      "name": "Event Farmhouse Venues Near Pune",
      "description": "Private farmhouse properties that double as event venues—ideal for intimate gatherings, celebrations, baby showers, or meetups in a relaxed, rustic setting."
    },
    {
      "name": "Wedding Farmhouse Options",
      "description": "Charming farmhouses offering wedding-ready lawns, rustic mandaps, basic decor options, catering access, and accommodation for small to medium-sized wedding ceremonies."
    }
  ],
  "tableData": [
    ["Farmhouse Rentals for Weekend Stays", "Private Farmhouse Near Pune"],
    ["Family Farmhouse on Rent in Morachi Chincholi", "Farmhouses with Kitchen Facilities"],
    ["Pet-Friendly Farmhouses", "Farmhouse with Garden and Outdoor Seating"],
    ["Budget-Friendly Farmhouse Options", "Farmhouse for Birthday Party"],
    ["Group Stay Farmhouse Near Pune", "Farmhouse with Local Food Availability"],
    ["Secluded Farmhouse for Peaceful Stay", "One-Day Farmhouse Rentals"],
    ["Traditional Village‑Style Farmhouse Stays", "Event Farmhouse Venues Near Pune"],
    ["Wedding Farmhouse Options", ""]
  ],



"whychoose": [
  {
    "WhyChooseheading": "Secluded Country Retreat",
    "WhyChoosedescription": "Morachi Chincholi farmhouses offer a private countryside escape just 50–60 km from Pune, providing the perfect setting for weekend getaways, family functions, or small events away from city crowds."
  },
  {
    "WhyChooseheading": "Spacious Outdoor Venues",
    "WhyChoosedescription": "These farmhouses feature large lawns, courtyards, and open-air patios ideal for group activities, barbecues, bonfires, kids’ games, and relaxed social gatherings of up to 100 people."
  },
  {
    "WhyChooseheading": "Tailored Rental Packages",
    "WhyChoosedescription": "Renters can choose from simple self‑catering options to comprehensive full-service packages that include catering, decor, sound systems, and event coordination—customizable to your needs and budget."
  },
  {
    "WhyChooseheading": "Comfort Meets Nature",
    "WhyChoosedescription": "Enjoy the best of both worlds: rustic farm charm with comforts like power backup, furnished interiors, clean restrooms, and outdoor seating—all set amidst farmland and peacocks."
  },
  {
    "WhyChooseheading": "Family & Corporate-Friendly",
    "WhyChoosedescription": "Perfect for private celebrations like birthdays, anniversaries, school events, or corporate offsites, these farmhouses offer privacy, flexibility, and the freedom to host your event your way."
  },
  {
    "WhyChooseheading": "Easy Accessibility",
    "WhyChoosedescription": "Located a quick drive from Pune via Pune–Ahmednagar road, the farmhouses are highly accessible by car or van—ideal for day rentals or overnight stays without tiring travel."
  }
]





























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Are farmhouses available for rent in Morachi Chincholi near Pune?',
    answer: 'Yes, there are several farmhouses available on rent in Morachi Chincholi, ideal for families, friends, or small group getaways from Pune.',
  },
  {
    id: 'FAQ2',
    question: 'What amenities do farmhouses in Morachi Chincholi offer?',
    answer: 'Farmhouses typically offer furnished rooms, clean bathrooms, private lawns, parking, outdoor seating, and optional food services.',
  },
  {
    id: 'FAQ3',
    question: 'Can I rent a farmhouse for a single day or overnight stay?',
    answer: 'Yes, most farmhouses offer flexible rental options for both day trips and overnight stays, depending on your preference.',
  },
  {
    id: 'FAQ4',
    question: 'Are these farmhouses suitable for private events?',
    answer: 'Absolutely. Many visitors rent farmhouses for birthday parties, family gatherings, reunions, or pre-wedding functions.',
  },
  {
    id: 'FAQ5',
    question: 'Is food provided at these farmhouses?',
    answer: 'Some farmhouses include traditional Maharashtrian meals in the package, while others allow you to bring or cook your own food.',
  },
  {
    id: 'FAQ6',
    question: 'How far is Morachi Chincholi from Pune?',
    answer: 'Morachi Chincholi is around 60 to 65 km from Pune, taking about 1.5 to 2 hours to reach by road.',
  },
  {
    id: 'FAQ7',
    question: 'Are farmhouses child and senior-friendly?',
    answer: 'Yes, most properties are safe and suitable for children and senior citizens with open spaces and basic comfort facilities.',
  },
  {
    id: 'FAQ8',
    question: 'Do the farmhouses have air conditioning or fans?',
    answer: 'Most farmhouses provide ceiling fans and natural ventilation, and some may offer air-conditioned rooms at an additional cost.',
  },
  {
    id: 'FAQ9',
    question: 'Do I need to book in advance?',
    answer: 'Yes, advance booking is highly recommended, especially on weekends, holidays, and during the winter and monsoon seasons.',
  },
  {
    id: 'FAQ10',
    question: 'Can I access nearby tourist spots while staying at a farmhouse?',
    answer: 'Yes, staying at a farmhouse gives easy access to peacock watching, village walks, Ranjangaon Ganpati Temple, and other local attractions.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Nikhil Gawade, Pune',
    feedback: "We rented a farmhouse in Morachi Chincholi for the weekend, and it was peaceful and refreshing. Great spot for a family outing.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Kavita Thombre, Kothrud',
    feedback: "The farmhouse was clean, well-maintained, and surrounded by nature. Perfect getaway from city life. Highly recommend for small groups.",
    rating: 5,
  },
];
































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi Farmhouse Near Pune on Rent",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi-farmhouse.jpg",
  "description": "Private and family-friendly farmhouse rentals near Pune in Morachi Chincholi. Features kitchen facilities, pet-friendly spaces, garden seating, budget options, event and wedding farmhouse venues, and peaceful traditional village-style stays.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "765"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6500",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/morachi-chincholi-farmhouse-rent"
  }
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi Farmhouse Near Pune on Rent | Private Farmhouse Stays</title>
  <meta 
    name="description" 
    content="Rent private and family-friendly farmhouses near Pune at Morachi Chincholi. Enjoy kitchen facilities, pet-friendly stays, garden seating, budget options, event venues, wedding farmhouse, and peaceful traditional village stays." 
  />
  <meta 
    name="keywords" 
    content="Farmhouse rentals for weekend stays, Private farmhouse near Pune, Family farmhouse on rent in Morachi Chincholi, Farmhouses with kitchen facilities, Pet-friendly farmhouses, Farmhouse with garden and outdoor seating, Budget-friendly farmhouse options, Farmhouse for birthday party, Group stay farmhouse near Pune, Farmhouse with local food availability, Secluded farmhouse for peaceful stay, One-day farmhouse rentals, Traditional village-style farmhouse stays, Event farmhouse venues near Pune, Wedding farmhouse options" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/36.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholifarmhous;